const VISIBLE_PROGRESS_START = 0;
const VISIBLE_PROGRESS_END = 1;

export function remainingWorkProgress(
  renderedSplats: number,
  baselineSplats: number,
  targetSplats: number,
): number {
  const span = Math.max(1, targetSplats - baselineSplats);
  const fill = Math.min(1, Math.max(0, (renderedSplats - baselineSplats) / span));
  const value = VISIBLE_PROGRESS_START + fill * (VISIBLE_PROGRESS_END - VISIBLE_PROGRESS_START);
  return Math.round(value * 1000) / 1000;
}

export { VISIBLE_PROGRESS_END, VISIBLE_PROGRESS_START };
